<template>
  <div class="h-full overflow-hidden">
    <el-table
      :data="tableData"
      :height="`calc(70% - 130px)`"
      highlight-current-row
      element-loading-background="rgba(0, 0, 0, 0.5)"
    >
      <!-- <el-table-column type="index" label="序号" min-width="20" align="center">
        <template slot-scope="scope">{{ scope.$index + 1 }}</template>
      </el-table-column> -->
      <el-table-column prop="name" label="设备信息名称" min-width="50%"></el-table-column>
      <el-table-column prop="value" label="值" min-width="50%"></el-table-column>
    </el-table>
    <!-- 设备设计图纸 -->
    <CardTitle :title="'设备设计图纸'" cardType="default"></CardTitle>
    <el-table
      :data="docTableData"
      :height="`calc(30% - 40px)`"
      :v-loading="loading"
      highlight-current-row
      element-loading-background="rgba(0, 0, 0, 0.5)"
    >
      <el-table-column type="index" label="序号" min-width="20" align="center">
        <template slot-scope="scope">{{ scope.$index + 1 }}</template>
      </el-table-column>
      <el-table-column prop="fileName" label="文件名称" min-width="80"></el-table-column>
      <el-table-column prop="value1" label="操作" min-width="30" align="center">
        <template slot-scope="scope">
          <span @click="viewFile(scope.row)" class="cursor-pointer">查看</span>
        </template>
      </el-table-column>
    </el-table>

    <file-view-dialog
      v-if="fileViewDialogVisible"
      @close="closeFileViewDialog"
      :fileSrc="viewFileSrc"
    ></file-view-dialog>
  </div>
</template>

<script>
import { HandoverManageApi, EquipmentRfidApi } from '@wiz-api/huizhou2'
import { ModelSceneApi } from '@wiz-api/scene-management'
import categoryTitle from '@/components/cockpit/CategoryTitle'
import CardTitle from '@/components/cockpit/CardTitle'
import FileViewDialog from './components/FileViewDialog'

const handoverManageApi = new HandoverManageApi()
const modelSceneApi = new ModelSceneApi()
const equipmentRfidApi = new EquipmentRfidApi()

export default {
  name: 'DeviceRealTimeInfo',
  components: {
    CardTitle,
    FileViewDialog,
  },
  props: {
    transferProps: {
      type: Object,
      defalut: () => {
        return {}
      },
    },
  },
  watch: {
    transferProps: {
      async handler() {
        await this.getSiteId()
        await this.getFileList()
        // await this.getDeviceBaseInfo()
      },
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      tableData: [],
      tagBasicAttrForm: [
        {
          label: '上级名称',
          value: '',
        },
        {
          label: '名称',
          value: '',
        },
        {
          label: '类别',
          value: '',
        },
        {
          label: '短描述',
          value: '',
        },
        {
          label: '长描述',
          value: '',
        },
      ],
      generalAttribute: [],
      siteId: '',
      modelFileId: [],
      docTableData: [],
      fileViewDialogVisible: false,
      viewFileSrc: '',
      loading: false,
    }
  },
  methods: {
    // 通过code获取位号
    async getSiteId() {
      const params = {
        code: this.transferProps.code,
      }
      const [err, res] = await handoverManageApi.getTagByCode1(params)
      const jsonRes = JSON.parse(res)
      if (!err && jsonRes) {
        this.siteId = jsonRes.data.siteId
        this.tableData = []
        // 基本属性
        this.tableData.push({
          name: '名称',
          value: jsonRes.data.name,
        })
        this.tableData.push({
          name: '编码',
          value: jsonRes.data.code,
        })
        this.tableData.push({
          name: '类别',
          value: jsonRes.data.className,
        })
        this.tableData.push({
          name: '短描述',
          value: jsonRes.data.shortDescription,
        })
        this.tableData.push({
          name: '长描述',
          value: jsonRes.data.longDescription,
        })
        // 通用属性
        /* eslint-disable */
        if (jsonRes.data.tagAttributeTemplates && jsonRes.data.tagAttributeTemplates.length > 0) {
          for (let item of jsonRes.data.tagAttributeTemplates[0].tagAttributeTemplateDetail) {
            let deviceProp = {
              name: item.displayName,
              value: '',
            }
            for (let valueItem of jsonRes.data.tagAttributeTemplates[0]
              .tagAttributeTemplateValues) {
              for (let valueKey in valueItem) {
                if (item.fieldName === valueKey) {
                  deviceProp.value = valueItem[valueKey]
                }
              }
            }
            this.tableData.push(deviceProp)
          }
        }
        // 对数据进行排序，有值的排在前面
        this.tableData.sort((a, b) => {
          if (a.value && !b.value) {
            return -1 // a.value 有值，排在前面
          } else if (!a.value && b.value) {
            return 1 // b.value 有值，排在前面
          } else {
            return 0 // 两者都有值或都为空，保持顺序
          }
        })
        /* eslint-enable */
      }
    },
    // 获取设备基本信息
    async getDeviceBaseInfo() {
      if (this.modelFileId.length === 0) {
        await this.getModelFileId()
      }
      const params = {
        siteId: this.siteId,
        code: this.transferProps.code,
        fileId: this.modelFileId[0],
      }
      const [err, res] = await handoverManageApi.getTagByFile(params)
      if (!err && res) {
        // 基本属性
        this.tagBasicAttrForm = [
          {
            name: '上级名称',
            value: res.data.tag.tagParentName,
          },
          {
            name: '名称',
            value: res.data.tag.name,
          },
          {
            name: '类别',
            value: res.data.tag.tagClassName,
          },
          {
            name: '短描述',
            value: res.data.tag.shortDescription,
          },
          {
            name: '长描述',
            value: res.data.tag.longDescription,
          },
        ]
        // 通用属性
        this.generalAttribute = res.data.generalAttribute.filter((item) => {
          return !!item.value
        })
        this.tableData = [...this.tagBasicAttrForm, this.generalAttribute]
      }
    },
    // 获取模型文件id
    async getModelFileId() {
      this.modelFileId = []
      const sceneId = localStorage.getItem('sceneId')
      if (!sceneId) return
      const [jsonErr, jsonRes] = await modelSceneApi.getModelSecenRelatedJson({ id: sceneId })
      if (!jsonErr) {
        const jsonData = JSON.parse(jsonRes)
        _.map(jsonData.children, (item) => {
          this.modelFileId.push(item.code.modelFileId)
        })
      }
    },
    // 获取文件列表
    async getFileList() {
      this.loading = true
      const [err, res] = await equipmentRfidApi.getEquipmentFiles({
        kkscode: this.transferProps.code,
      })
      if (!err) {
        this.docTableData = res
      }
      this.loading = false
    },
    closeFileViewDialog() {
      this.fileViewDialogVisible = false
    },
    openFileViewDialog(row) {
      this.viewFileSrc = row.src
      this.fileViewDialogVisible = true
    },
    // 查看文件
    viewFile(file) {
      const fileUrl = _.get(
        Wiz,
        'globalSettings.dynamicModules.modules["visualization-cockpit"].config'
      )?.deviceDocumentUrl
      if (fileUrl) {
        // window.open(`${fileUrl}${file.md5}`, '_blanck')
        this.viewFileSrc = `${fileUrl}${file.md5}`
        this.fileViewDialogVisible = true
      }
    },
  },
  computed: {
    // 惠州模型名称
    hzBaseModelName() {
      return Wiz.globalSettings.globalConfig?.hzBaseModelName || ''
    },
  },
  async created() {
    await this.getModelFileId()
  },
  beforeDestroy() {},
}
</script>

<style lang="scss" scoped>
::v-deep {
  .el-table {
    font-size: 13px;
    .cell {
      line-height: 14px;
    }
  }
}

::v-deep {
  .info-form {
    .el-form-item {
      margin-bottom: 15px;
    }
    .el-form-item__label {
      line-height: 20px;
      padding-bottom: 5px;
    }
    .el-input {
      .el-input__inner {
        border-color: #fff !important;
      }
    }
  }
}
</style>
